<template>
    <div>
        <NavBar />
        <div class="container mx-auto">
            <header>
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold leading-tight text-gray-900">
                        Campaign
                    </h1>
                </div>
            </header>

            <main class="container mx-auto">
                <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                    <div class="px-4 py-6 sm:px-0">
                        <div class="flex flex-wrap">
                            <div class="w-full md:w-2/3 px-2">
                                <div class="bg-white p-4">
                                    <label class="block text-gray-700 text-sm font-bold my-2" for="selectedCaller">Callback Number</label>

                                    <select
                                        class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                                        id="selectedCaller"
                                        name="selectedCaller"
                                        @change="handleChange"
                                        required
                                    >
                                        <option
                                            v-for="caller in verifiedCallers"
                                            :key="caller.id"
                                            :value="caller.id"
                                        >
                                            {{ caller.phone_number }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="w-full md:w-1/3">
                                <Summary :summary="summary" />

                                <button
                                    class="bg-green-500 hover:bg-green-700 text-white font-bold text-sm py-2 px-4 rounded my-4"
                                    @click="save"
                                >
                                    Next
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
        <!-- <div class="container-lg clearfix">
            <div class="tw-flex tw-flex-wrap">
                <div class="tw-w-full sm:tw-w-full md:tw-w-2/3 tw-px-3">
                    <div class="Box">
                        <div class="Telepathy-Box-header">
                            <h3 class="Box-title">
                                Setup Campaign
                            </h3>
                        </div>
                        <div class="div">
                            <div class="Box-row">
                                <div class="container-lg gutter clearfix">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <dt>
                                                
                                            </dt>
                                            <dd>
                                                
                                            </dd>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="Box-row">
                                <div class="container-lg gutter clearfix">
                                    <div class="col-6 float-left pointer">
                                        <div class="form-group">
                                            <dt>
                                                <label for="frequency">Speed of Messages (Per Minute)</label>
                                            </dt>
                                            <dd>
                                                <select
                                                    class="form-select btn-block"
                                                    id="frequency"
                                                    name="frequency"
                                                    @change="handleChange"
                                                    :value="frequency"
                                                    required
                                                >
                                                    <option value="40">40</option>
                                                    <option value="30">30</option>
                                                    <option value="20">20</option>
                                                    <option value="10">10</option>
                                                </select>
                                            </dd>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="Box-row">
                                <div class="container-lg gutter clearfix">
                                    <div class="col-6 float-left pointer">
                                        <div class="form-group">
                                            <dt>
                                                <label for="datetimepicker1">Delivery Date</label>
                                            </dt>
                                            <dd>
                                                <input
                                                    class="form-control"
                                                    id='datetimepicker1'
                                                    name="campaign_caller[startDate]"
                                                    type="date"
                                                    placeholder="Select Date"
                                                    required
                                                />
                                            </dd>
                                        </div>
                                    </div>
                                    <div class="col-6 float-left pointer">
                                        <div class="form-group">
                                            <dt>
                                                <label for="timepicker">Delivery Time</label>
                                            </dt>
                                            <dd>
                                                <input
                                                    class="form-control"
                                                    id="timepicker"
                                                    name="campaign_caller[startTime]"
                                                    type="time"
                                                    placeholder="Select Time"
                                                    required
                                                />
                                            </dd>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div> -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Summary from "../components/Summary";
import NavBar from "../components/NavBar";
import { TelepathyFormData } from "../store/TelepathyFormData";

export default {
    name: "Campaign",
    components: {
        NavBar,
        Summary,
    },
    data() {
        return {
            summary: {
                "message_type": "",
                "contact_list_id": "",
                "contact_list_type": "",
                "text_message": "",
                "message_recording_type": "",
                "uploaded_audio_file": ""
            }
        }
    },
    methods: {
        handleChange({ target }) {
            const payload = {
                prop: target.name,
                val: target.value
            }
            this.$store.commit("change", payload);
        },
        save() {
            // const callerData = new TelepathyFormData("create_caller_request");

            // callerData
            //     .append("name", this.callerName)
            //     .append("phone_number", this.callerPhoneNumber)
            // ;

            // this.$api.post("callers", callerData)
            //     .then(({ data: { payload } }) => {
            //         this.$store.commit("change", {
            //             prop: "selectedCaller",
            //             val: payload.id
            //         });
            //     })
            //     .then(response => {
            //         this.$router.push(this.nextRoute);
            //     })
            //     .catch(error => {
            //     });
            this.$router.push(this.nextRoute);
        }
    },
    computed: {
        nextRoute() {
            return `${this.$route.meta.link}`
        },
        verifiedCallers() {
            return this.callers.filter(caller => caller.verified === true)
        },
        ...mapGetters([
            "messageTypeFormatted",
            "callerName",
            "callerPhoneNumber",
            "frequency",
            "contactList",
            "selectedList",
            "contactListType",
            "message",
            "messageType",
            "audioUploadType",
            "uploadedFileName",
            "recording",
            "callers",
            "selectedCaller"
        ]),
    },
    mounted() {
        this.$store.dispatch("loadCallers");

        this.summary.message_type = this.messageTypeFormatted;
        const contactList = this.contactList(this.selectedList);

        if(contactList != undefined) {
            this.summary.contact_list_type = this.contactListType;
            this.summary.contact_list_id = contactList.description;
        }

        if(this.messageType === "sms") {
            if(this.message !== "") {
                this.summary.text_message = "Written";
            }
        } else if(this.messageType === "audio") {
            this.summary.message_recording_type = this.audioUploadType;
            this.summary.uploaded_audio_file = this.uploadedFileName(this.recording);
        }
    }
}
</script>